import { render, staticRenderFns } from "./StoryPeertubePlayer.vue?vue&type=template&id=6a14641c&"
import script from "./StoryPeertubePlayer.vue?vue&type=script&lang=js&"
export * from "./StoryPeertubePlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports